import React from 'react';
import { LocationViewModel } from '../../models/locations';
import { Button, Dialog, Icon, Grid, AppBar, Toolbar, IconButton, Typography, Tooltip } from '@material-ui/core';

import { useStyles } from './styles';
import FarmLocations from '../../components/FarmLocations';
import { useTranslation } from 'react-i18next';

interface LocationSearchSelectModalProps {
  opened: boolean;
  onModalAction: (locations: LocationViewModel[] | null) => void;
}

const LocationSearchSelectModal: React.FC<any> = ({ opened, onModalAction }: LocationSearchSelectModalProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [seelctedLocations, setSelectedLocations] = React.useState([] as LocationViewModel[]);

  const closeDialog = (text: string | null) => {
    if (text == null) {
      onModalAction(null);
      return;
    }

    onModalAction && onModalAction(seelctedLocations);
  };

  const handleLocationsSelected = (locations: LocationViewModel[]) => {
    setSelectedLocations(locations);
  };

  return (
    <Dialog fullScreen open={opened} onClose={() => closeDialog(null)}>
      <AppBar className={classes.appBar} color="primary">
        <Toolbar>
          <Grid item container justifyContent="space-between" alignItems="center">
            <Grid item container alignItems="center" xs={12} sm={6}>
              <Tooltip arrow title={t('f-com-close-search-dlg')}>
                <IconButton edge="start" color="inherit" onClick={() => closeDialog(null)} aria-label="close">
                  <Icon>{'close'}</Icon>
                </IconButton>
              </Tooltip>

              <Typography variant="h6" className={classes.title}>
                {t('f-loc-search-select-title')}
              </Typography>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                autoFocus
                color="inherit"
                disabled={!seelctedLocations.length}
                startIcon={<Icon>{'check'}</Icon>}
                onClick={() => closeDialog('OK')}
              >
                {t('f-loc-search-select-confirm')}
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Grid container style={{ padding: 16 }}>
        <FarmLocations mode="search" onLocationsSelected={handleLocationsSelected} />
      </Grid>
    </Dialog>
  );
};

export default LocationSearchSelectModal;
